import React from "react";
import "./header.css";
import circle from "../images/card-logo.svg";
interface Props {
  cvc: null | string;
  cardNumber: string | null;
  cardholder: string | null;
  month: string | null;
  year: string | null;
}
function Header(props: Props) {
  return (
    <header>
      <div className="cards">
        <div className="card-back">
          <div className="cvc">{props.cvc ? props.cvc : "000"}</div>
        </div>
        <div className="card-front">
          <img src={circle} alt="icon"></img>
          <div className="card-number">
            <h2>
              {props.cardNumber ? props.cardNumber : "0000 0000 0000 0000"}
            </h2>
          </div>
          <div className="card-holder">
            {props.cardholder ? props.cardholder : "Jane Appleseed"}
            <div className="expire">
              {props.month ? props.month : "00"}/
              {props.year ? props.year : "00"}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
export default Header;
